const playerFormationReducer = (state = null, action) => {
  switch (action.type) {
    case 'ADMIN_PLAYER_FORMATION':
      return action.data
    default:
      return state
  }
}

export default playerFormationReducer
